import { render, staticRenderFns } from "./Importar_Maxisacos.vue?vue&type=template&id=20b8a123&scoped=true&"
import script from "./Importar_Maxisacos.vue?vue&type=script&lang=js&"
export * from "./Importar_Maxisacos.vue?vue&type=script&lang=js&"
import style0 from "./Importar_Maxisacos.vue?vue&type=style&index=0&id=20b8a123&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8a123",
  null
  
)

export default component.exports